// libs
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

// constants
import { PROBE_HEIGHT, PROBE_WIDTH, ZOOM_HEIGHT, ZOOM_WIDTH } from './constants';

export const ZoomContainer = styled.div`
  position: absolute;
  z-index: 5;
  cursor: crosshair;

  .zm-probe {
    position: absolute;
    height: ${PROBE_HEIGHT}px;
    width: ${PROBE_WIDTH}px;
    background: ${({ theme }) => hexToRgb(theme.colors.surface, 0.5)};
  }

  .zm-image-cnt {
    position: absolute;
    border: 1px solid ${({ theme }) => hexToRgb(theme.colors.inverse, 0.2)};
    background-color: ${({ theme }) => theme.colors.surface};
    box-shadow: 0 0 10px ${({ theme }) => hexToRgb(theme.colors.inverse, 0.2)};
    right: ${-1 * (ZOOM_WIDTH + 20)}px;
    top: 0;
    height: ${ZOOM_HEIGHT}px;
    width: ${ZOOM_WIDTH}px;
    overflow: hidden;
  }

  .zm-image {
    position: absolute;
    display: block;
  }
`;
